import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import Styles from './LoadingDesign.module.scss'
import cx from 'classnames'
import { getTemplatePreviewCloudinaryUrl } from 'components/Design/utils/getTemplatePreviewCloudinaryUrl'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { useState } from 'react'

interface Props {
  templateId?: number
}

export const LoadingDesign = observer(({ templateId }: Props) => {
  const { visualElements } = useRootStore()
  const { selectedImages } = useImagePickerContext()
  const template = templateId ? visualElements.getElement(templateId) : undefined
  const url = template ? getTemplatePreviewCloudinaryUrl(template.preview_url, { height: 278 }) : ''
  const [loaded, setLoaded] = useState(false)

  return (
    <>
      <div className={cx(Styles.container, { [Styles.column]: template && template?.width > template?.height })}>
        {selectedImages[0] && (
          <div className={Styles.wrapper}>
            <div className={Styles.imageContainer}>
              <div className={Styles.textContainer}>
                <Text variant="placeholder">Your image</Text>
              </div>
              <div className={Styles.shimmererContainer}>
                <div className={Styles.shimmerer} />
                <img className={Styles.image} src={selectedImages[0].url} alt="design media file" />
              </div>
            </div>
          </div>
        )}
        <div className={Styles.wrapper}>
          <div className={cx(Styles.templateContainer, { [Styles.noImage]: !selectedImages[0] })}>
            <div className={Styles.textContainer}>{loaded && <Text variant="placeholder">Your template</Text>}</div>
            <div className={Styles.shimmererContainer}>
              {loaded && <div className={Styles.shimmerer2} />}
              <img className={Styles.template} src={url} alt="design template" onLoad={() => setLoaded(true)} />
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.headingWrapper}>
        <Heading color="var(--dark-60)" level={5}>
          Combining your assets into something great
          <LoadingEllipses />
        </Heading>
      </div>
    </>
  )
})
